export default __webpack_public_path__ + "static/media/2135.ecfca121.png";